import styled from 'styled-components';
import { Layout } from 'antd';

export const { Sider } = Layout;

export const SiderWrapper = styled(Sider)`
  overflow: auto !important;
  height: 100vh !important;
  position: fixed !important;
  left: 0;
  top: 0;
  bottom: 0;
  .ant-menu {
    .ant-menu-item {
      &.ant-menu-item-selected {
        background: inherit;
        color: #ffffff;
        .anticon {
          color: #ffffff;
        }
      }
    }
  }
`;
